module.exports = __webpack_public_path__ + "img/key-white-m.e852c40c.svg";